'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
export default class ErrorList extends Component {
  render() {
    const {
      errors = []
    } = this.props;

    if (!errors.length) {
      return null;
    }

    return /*#__PURE__*/_jsx(UIList, {
      children: errors.map((error, i) => /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: error
      }, i))
    });
  }

}
ErrorList.propTypes = {
  errors: PropTypes.array
};